import { makeAutoObservable } from 'mobx';

export class ProfileStore {
  versionId = '';
  isEditModalOpen = false;
  isLogoutModalOpen = false;
  countryCode = '1';
  localImagePreview: string | null = null;
  selectedFile: File | null = null;
  private profileInfo: any = null;

  constructor() {
    makeAutoObservable(this);
  }

  setVersionId(id: string) {
    this.versionId = id;
  }

  setEditModalOpen(open: boolean) {
    this.isEditModalOpen = open;
  }

  setLogoutModalOpen(open: boolean) {
    this.isLogoutModalOpen = open;
  }

  setCountryCode(code: string) {
    this.countryCode = code;
  }

  setProfileInfo(info: any) {
    this.profileInfo = info;
  }

  setLocalImagePreview(image: string | null) {
    this.localImagePreview = image;
  }

  setSelectedFile(file: File | null) {
    this.selectedFile = file;
  }

  resetImageUpload() {
    this.localImagePreview = null;
    this.selectedFile = null;
  }

  get isProfileInfo() {
    return this.profileInfo;
  }

  reset() {
    this.versionId = '';
    this.isEditModalOpen = false;
    this.isLogoutModalOpen = false;
    this.countryCode = '1';
    this.localImagePreview = null;
    this.selectedFile = null;
    this.profileInfo = null;
  }
}

export const profileStore = new ProfileStore();
